var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DEFORMER_MANIP_ENUM, TRANSFORM_DIRECTION } from "../enums";
import { TextDeformer } from "./TextDeformer";
var TextProgressDeformer = /** @class */ (function (_super) {
    __extends(TextProgressDeformer, _super);
    function TextProgressDeformer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._deformerType = [DEFORMER_MANIP_ENUM.VERTEX, DEFORMER_MANIP_ENUM.UV];
        _this._progresses = [];
        _this._direction = TRANSFORM_DIRECTION.TOP_TO_BOTTOM;
        _this._indexArray = [];
        _this._uMinMaxXArray = [];
        _this._uMinMaxYArray = [];
        _this._uMinMaxUArray = [];
        _this._uMinMaxVArray = [];
        return _this;
    }
    TextProgressDeformer.prototype._uniforms = function () {
        // when we change a value, does it sync up one uniform or all of them?
        // we could just copy over the min/max values as that's what we're using
        return {
            uDirection: this.direction,
            uProgresses: this.progresses,
            uMinMaxXArray: this._uMinMaxXArray,
            uMinMaxYArray: this._uMinMaxYArray,
            uMinMaxUArray: this._uMinMaxUArray,
            uMinMaxVArray: this._uMinMaxVArray,
        };
    };
    Object.defineProperty(TextProgressDeformer.prototype, "progresses", {
        get: function () {
            return this._progresses;
        },
        set: function (value) {
            this._validateData(value, 1);
            this._progresses = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextProgressDeformer.prototype, "direction", {
        get: function () {
            return this._direction;
        },
        set: function (value) {
            this._direction = value;
        },
        enumerable: false,
        configurable: true
    });
    // TODO: rename aWeight to aVertexWeight
    // header
    TextProgressDeformer.prototype._vertexHeader = function () {
        var transformLength = this._progresses.length;
        var arrayLength = this._uMinMaxXArray.length;
        var totalUniformCount = (arrayLength * 4) + transformLength;
        // maybe we should use a data texture instead of uniforms?
        // or just attributes?
        if (totalUniformCount > 1024) {
            // see https://alteredqualia.com/tools/webgl-features/
            throw Error("Too many uniforms! " + totalUniformCount);
        }
        return "\n            attribute float aWeight; //[".concat(this._weights.length, "]\n            attribute float aVertexIndex; //[").concat(this._indexArray.length, "]\n            \n            uniform float uDirection;\n            uniform float uProgresses[").concat(transformLength, "];\n            uniform vec2 uMinMaxXArray[").concat(arrayLength, "];\n            uniform vec2 uMinMaxYArray[").concat(arrayLength, "];\n            uniform vec2 uMinMaxUArray[").concat(arrayLength, "];\n            uniform vec2 uMinMaxVArray[").concat(arrayLength, "];\n            \n            varying vec2 vMinMaxU;\n            varying vec2 vMinMaxV;\n            varying float vProgress;\n            varying float vDirection;\n        ");
    };
    // functions
    TextProgressDeformer.prototype._vertBody = function () {
        return "\n            vec3 getVertexPosition".concat(this.index, "(vec3 inputPosition) {\n                int direction = int(uDirection);\n                int progressTransformIndex = int(aWeight);\n                int vertexIndex = int(aVertexIndex);\n                float progress = clamp(uProgresses[progressTransformIndex], 0.0, 1.0);\n                float minX = uMinMaxXArray[vertexIndex].x;\n                float maxX = uMinMaxXArray[vertexIndex].y;\n                float minY = uMinMaxYArray[vertexIndex].x;\n                float maxY = uMinMaxYArray[vertexIndex].y;\n                \n                float yPos = inputPosition.y;\n                if (direction == 2) { // top to bottom\n                    float yRange = maxY - minY;\n                    float yCoord = (inputPosition.y - minY) / yRange;\n                    float yOffset = yRange * (1.0 - progress);\n                    yPos = minY + ((yRange * yCoord) * progress) + yOffset;\n                }\n                else if (direction == 3) { // bottom to top\n                    float yRange = maxY - minY;\n                    float yCoord = (yRange - (inputPosition.y - minY)) / yRange;\n                    float yOffset = yRange * (1.0 - progress);\n                    yPos = minY + (maxY - ((yRange * yCoord) * progress)) - yOffset;\n                }\n                vec3 outPosition = vec3(inputPosition.x, yPos, inputPosition.z);\n                return outPosition;\n            }\n        ");
    };
    // main
    TextProgressDeformer.prototype._vertexMain = function () {
        return "\n            int progressTransformIndex = int(aWeight);\n            int vertexIndex = int(aVertexIndex);\n            \n            vMinMaxU = uMinMaxUArray[vertexIndex];\n            vMinMaxV = uMinMaxVArray[vertexIndex];\n            \n            vProgress = clamp(uProgresses[progressTransformIndex], 0.0, 1.0);\n            vDirection = uDirection;\n        ";
    };
    // header
    TextProgressDeformer.prototype._fragmentHeader = function () {
        return "\n            varying float vMinU;\n            varying float vMaxU;\n            varying float vMinV;\n            varying float vMaxV;\n            \n            varying vec2 vMinMaxU;\n            varying vec2 vMinMaxV;\n            \n            varying float vProgress;\n            varying float vDirection;\n        ";
    };
    // functions
    TextProgressDeformer.prototype._fragBody = function () {
        return "\n            vec2 getUV".concat(this.index, "(vec2 inputUV) {\n                int direction = int(vDirection);\n                \n                float newV = inputUV.y;\n                if (direction == 2) {\n                    float vRange = vMinMaxV.y - vMinMaxV.x;\n                    float vCoord = (inputUV.y - vMinMaxV.x) / vRange;\n                    newV = vMinMaxV.x + ((vRange * vCoord) * vProgress);\n                }\n                else if (direction == 3) {\n                    float vRange = vMinMaxV.y - vMinMaxV.x;\n                    float vCoord = (vMinMaxV.y - inputUV.y) / vRange;\n                    newV = vMinMaxV.y - ((vRange * vCoord) * vProgress);\n                }\n                vec2 outputUV = vec2(inputUV.x, newV);\n                return outputUV;\n            }       \n        ");
    };
    TextProgressDeformer.prototype._updateProperties = function () {
        _super.prototype._updateProperties.call(this);
        this._generateIndexArray();
        this._assignIndexArray();
        this._generateMinMaxXYUVArrays();
    };
    TextProgressDeformer.prototype._resetStateOnProperties = function (length) {
        this._progresses = new Array(length).fill(1.0);
    };
    // we could move this to the geometry build step
    // or maybe we don't actually need this? maybe we can count
    // vertices in the shader?
    TextProgressDeformer.prototype._generateIndexArray = function () {
        var indices = [];
        for (var i = 0; i < this.parent.glyph.length; i++) {
            indices.push(i, i, i, i);
        }
        this._indexArray = indices;
    };
    TextProgressDeformer.prototype._assignIndexArray = function () {
        var attribute = this.parent.geometry.getAttribute('aVertexIndex');
        if (!attribute) {
            this.parent.geometry.addAttribute('aVertexIndex', this._indexArray, 1);
            return;
        }
        var buffer = this.parent.geometry.getBuffer('aVertexIndex');
        buffer.data = new Float32Array(this._indexArray);
        // console.log('vertexIndex', this._indexArray)
    };
    TextProgressDeformer.prototype._generateMinMaxXYUVArrays = function () {
        // get the x,y, u and v min max for each glyph
        var vertexArray = this.parent._fontAtlasTextGeometry._vertexArray;
        var uvArray = this.parent._fontAtlasTextGeometry._uvArray;
        this._uMinMaxXArray = [];
        this._uMinMaxYArray = [];
        this._uMinMaxUArray = [];
        this._uMinMaxVArray = [];
        for (var i = 0; i < vertexArray.length; i += 8) {
            this._uMinMaxXArray.push(vertexArray[i + 4], vertexArray[i + 0]);
            this._uMinMaxYArray.push(vertexArray[i + 5], vertexArray[i + 1]);
            this._uMinMaxUArray.push(uvArray[i + 4], uvArray[i + 0]);
            this._uMinMaxVArray.push(uvArray[i + 5], uvArray[i + 1]);
        }
        // console.log('minMaxY', this._uMinMaxYArray);
    };
    return TextProgressDeformer;
}(TextDeformer));
export { TextProgressDeformer };
